import React from 'react';

import { useFormikContext } from 'formik';
import { useTranslation } from 'i18n/hooks';
import { Button, Checkbox, Drawer, Label } from 'revibe-ui';
import { SpacedContainer } from 'revibe-ui';

import { useBoolean } from 'modules/common/hooks';
import { useCategories } from 'modules/item/hooks/useCategories';
import { ITEM_FILTERS } from 'modules/item/utils/itemFilter';

import { Tag } from 'ui/components/Tag';

import { PriceFilter } from './PriceFilter';
import { SexFilter } from './SexFilter';
import { SizeFilter } from './SizeFilter';
import { SortFilter } from './SortFilter';
import { MarketplaceAPI } from 'revibe-api';
import { fontVariables } from 'ui/fonts/fontVariables';

type Props = {
  filtersCount: number;
};

export const ItemsFiltersMobile = ({ filtersCount }: Props) => {
  const { tu } = useTranslation('listing.filters');
  const [isFiltersModalOpen, openFiltersModal, closeFiltersModal] =
    useBoolean();
  const { values, setFieldValue, handleSubmit } =
    useFormikContext<MarketplaceAPI.ItemFilters>();
  const handleClose = () => {
    closeFiltersModal();
  };
  useCategories();
  return (
    <div>
      <div className="sticky top-0 left-0 flex items-center justify-start gap-4 px-4 py-2">
        <Button
          variant="subtle"
          onClick={() => {
            openFiltersModal();
          }}
        >
          {filtersCount > 0 ? (
            <span>
              {tu('heading')} ({filtersCount}){' '}
            </span>
          ) : (
            <span>{tu('heading')}</span>
          )}
        </Button>
        {values[ITEM_FILTERS.MIN_PRICE] > 0 && (
          <Tag>{`${tu('minPrice')}: ${values[ITEM_FILTERS.MIN_PRICE]} €`}</Tag>
        )}
        {values[ITEM_FILTERS.MAX_PRICE] < 1000 && (
          <Tag>{`${tu('maxPrice')}: ${values[ITEM_FILTERS.MAX_PRICE]} €`}</Tag>
        )}
        {values[ITEM_FILTERS.SELLER_NAME] !== null &&
          values[ITEM_FILTERS.SELLER_NAME] !== undefined &&
          values[ITEM_FILTERS.SELLER_NAME] !== '' && (
            <Tag>
              {`${tu('sellerName')}: ${values[ITEM_FILTERS.SELLER_NAME]}`}
            </Tag>
          )}
        {values[ITEM_FILTERS.SIZE] !== null &&
          values[ITEM_FILTERS.SIZE] !== undefined &&
          values[ITEM_FILTERS.SIZE] !== '' && (
            <Tag>{`${tu('size')}: ${values[
              ITEM_FILTERS.SIZE
            ]?.toUpperCase()}`}</Tag>
          )}
      </div>
      <Drawer
        scrollable
        open={isFiltersModalOpen}
        position="right"
        onOpenChange={handleClose}
        className={fontVariables}
      >
        <form className="h-full overflow-y-auto">
          <h1 className="font-formula p-4 text-2xl uppercase">
            {tu('heading')}
          </h1>

          <div className="w-full cursor-pointer p-4">
            <SexFilter />
          </div>

          <div className="w-full cursor-pointer p-4">
            <SortFilter />
          </div>
          <div className="w-full cursor-pointer p-4">
            <SizeFilter />
          </div>
          <div className="w-full cursor-pointer p-4">
            <PriceFilter />
          </div>
          <div className="flex w-full cursor-pointer items-center space-x-2 p-4 pb-36 text-gray-500">
            <Checkbox
              id="only-preorder"
              checked={values[ITEM_FILTERS.IN_PREORDER]}
              onCheckedChange={() => {
                setFieldValue(
                  ITEM_FILTERS.IN_PREORDER,
                  !values[ITEM_FILTERS.IN_PREORDER]
                );
                handleSubmit();
              }}
            />
            <Label htmlFor="only-preorder">{tu('only-preorder', 'shop')}</Label>
          </div>
          <SpacedContainer
            type="horizontal"
            spacing="small"
            centered
            className="fixed bottom-0 right-0 w-full bg-white p-4"
          >
            <Button
              className="w-full"
              onClick={() => {
                handleSubmit();
                handleClose();
              }}
            >
              {tu('apply')}
            </Button>
            <Button variant="outline" className="w-full" onClick={handleClose}>
              {tu('close', 'common')}
            </Button>
          </SpacedContainer>
        </form>
      </Drawer>
    </div>
  );
};
